import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Check, LucideIcon } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';

/** One of the two visibilities, as a selectable row. */
export const VisibilityOption = memo(
  ({
    icon: Icon,
    title,
    detail,
    selected,
    onPress,
  }: {
    icon: LucideIcon;
    title: string;
    detail: string;
    selected: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Pressable
        accessibilityRole="radio"
        accessibilityState={{ checked: selected }}
        onPress={onPress}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(12),
          padding: rpx(12),
          borderRadius: rpx(12),
          borderWidth: 1,
          borderColor: selected ? aiColors.primary : aiColors.border,
          backgroundColor: selected
            ? tint(aiColors.primary, 0.05)
            : aiColors.card,
        }}
      >
        <Icon
          size={18}
          color={selected ? aiColors.primary : aiColors.mutedForeground}
        />
        <View style={{ flex: 1, gap: rpx(2) }}>
          <Typography.Text medium size={rpx(13)} color={aiColors.foreground}>
            {title}
          </Typography.Text>
          <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
            {detail}
          </Typography.Text>
        </View>
        {selected ? <Check size={16} color={aiColors.primary} /> : null}
      </Pressable>
    );
  },
);
